import React, { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { Alert, Button } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophone } from "@fortawesome/free-solid-svg-icons/faMicrophone";
import {
  fetchVoice,
  voiceTranslationEnabledForUser,
} from "../../lib/candyvoice";
import { voiceEnrollmentModalOpenAtom } from "./VoiceEnrollmentModal";

// Above the meetings of the home page: invites the user who can record their
// voice (the free demo, Voice Trust+, Enterprise: see
// voiceTranslationEnabledForUser) and hasn't yet to record it, with the
// button opening VoiceEnrollmentModal (mounted by the header). Gone once the
// voice is recorded.
export const VoiceInvite: React.FC<{ currentUser: User }> = ({
  currentUser,
}) => {
  const enabled = voiceTranslationEnabledForUser(currentUser);
  const [open, setOpen] = useAtom(voiceEnrollmentModalOpenAtom);
  // null while we don't know
  const [recorded, setRecorded] = useState<boolean | null>(null);

  // again when the modal closes: the voice may have just been recorded
  useEffect(() => {
    if (!enabled || open) return;
    let cancelled = false;
    fetchVoice().then(
      (voice) => !cancelled && setRecorded(voice.complete),
      // CandyVoice unreachable: no invitation rather than a broken one
      () => !cancelled && setRecorded(true)
    );
    return () => {
      cancelled = true;
    };
  }, [enabled, open]);

  if (!enabled || recorded !== false) return null;

  return (
    <Alert
      severity="info"
      icon={<FontAwesomeIcon icon={faMicrophone} />}
      sx={{ mx: 3, mb: 3, alignItems: "center" }}
      action={
        <Button
          variant="contained"
          color="secondary"
          size="small"
          onClick={() => setOpen(true)}
          sx={{ whiteSpace: "nowrap" }}
        >
          <FormattedMessage
            id="voice-invite.button"
            defaultMessage="Record my voice"
          />
        </Button>
      }
    >
      <FormattedMessage
        id="voice-invite.text"
        defaultMessage="Record your voice once (about 3 minutes): in your meetings, your words are then translated and read in your own voice, in the language of each participant."
      />
    </Alert>
  );
};
